export const RetailerApprovalStatus = { PENDING: 'pending', APPROVED: 'approved' };
